import { Injectable } from "@angular/core";
import { AuthService } from "../core/authentication/authentication.servicie";



@Injectable()
export class PaginationService {

    constructor(private authService: AuthService) {
    }

/**
* this service save the pageConfig Object in local Storage when page change event call.
* @param pageNumber
* @param menu (menu name)
*/
    paginationService(pageNumber: any, menu: any) {
        let obj = {
            'menu': menu,
            'currentPage': pageNumber
        }
        this.authService.saveValue('pageConfig', obj)
    }
    getPageNumber(menu: any){
        if(this.authService.getValueForKey('pageconfig').menu == menu){
            return true;
        }
    }

}
